import { axios } from '@argon/app/axios'

const NAMESPACE = 'refusals'

const state = {
  refusals: []
}

const mutations = {
  SET_REFUSALS: (state, payload) => {
    state.refusals = payload
  }
}
const actions = {
  listRefusals: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      axios({
        url: '/deal-refusals',
        method: 'GET'
      })
        .then(({ data }) => {
          commit('SET_REFUSALS', data.items)
          resolve(data.items)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
const getters = {
  refusals: (state) => state.refusals
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export { NAMESPACE }
